import { FIVE_DAY_EXPECTATIONS } from "@/components/sample/fiveDayProtocol";
import { ProtocolIntroduction, ProtocolDirections } from "@/components/sample/ProtocolDirections";

export const InviteProtocol = () => (
  <section className="min-w-0" aria-labelledby="invite-protocol-title" data-testid="invite-protocol">
    <div className="sample-accent label !text-[9px]" data-testid="invite-protocol-label">The five-day protocol</div>
    <h2 id="invite-protocol-title" className="sample-editorial-strong mt-3 editorial text-[32px] leading-tight md:text-[34px]" data-testid="invite-protocol-title">Try it for the next five days.</h2>
    <ProtocolIntroduction prefix="invite" />
    <ProtocolDirections prefix="invite" />
    <h3 className="mt-5 border-t border-white/15 pt-4 label !text-[8px] !text-white/55" data-testid="invite-expectations-title">What to expect</h3>
    <div className="mt-4 space-y-4">
      {FIVE_DAY_EXPECTATIONS.map(([day, copy]) => (
        <p key={day} className="grid grid-cols-[42px_minmax(0,1fr)] gap-3 text-[13px] leading-relaxed" data-testid={`invite-expectation-day-${day}`}>
          <span className="sample-accent font-mono" data-testid={`invite-expectation-label-${day}`}>Day {day}</span><span className="text-white/75" data-testid={`invite-expectation-copy-${day}`}>— {copy}</span>
        </p>
      ))}
    </div>
    <p className="mt-5 text-[11px] text-white/50" data-testid="invite-results-note">Individual experiences vary.</p>
  </section>
);